/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const LoginB2b = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post('/api/b2b/login', {
        email,
        password,
      });

      // ✅ on stocke le token ET l’utilisateur
      localStorage.setItem('token_b2b', res.data.token);
      if (res.data.user) {
        localStorage.setItem('b2bUser', JSON.stringify(res.data.user));
      }

      alert('Connexion réussie !');
      // ✅ redirection vers le catalogue protégé
      window.location.href = '/b2b/catalogue-b2b';
    } catch (err) {
      console.error('[LoginB2b] erreur =', err);
      alert(err.response?.data?.message || 'Erreur login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img
          src="/assets/svg/logos/logo.svg"
          alt="KeplerLogo"
          width="258px"
          style={{ display: 'flex', margin: '0px auto' }}
        />
        <h2>Connexion B2B</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email :</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="ex: user@b2b.com"
            />
          </div>

          <div className="form-group">
            <label>Mot de passe :</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Votre mot de passe"
            />
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
          <div style={{ marginTop: 10 }}>
            <Link to="/b2b/forgot-password">Mot de passe oublié ?</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginB2b;
